export default "__VITE_ASSET__DulG2vK9__"